import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "../../lib/utils";

export function Table({
  className,
  children,
  dense = false,
}: {
  className?: string;
  children: ReactNode;
  dense?: boolean;
}): JSX.Element {
  return <table className={cn("w-full text-left text-sm text-slate-700", dense && "table-dense", className)}>{children}</table>;
}

export function TableHead({ className, children }: { className?: string; children: ReactNode }): JSX.Element {
  return <thead className={cn("border-b border-slate-200 bg-slate-50 text-xs uppercase text-slate-500", className)}>{children}</thead>;
}

export function TableBody({ className, children }: { className?: string; children: ReactNode }): JSX.Element {
  return <tbody className={cn("divide-y divide-slate-100", className)}>{children}</tbody>;
}

export function TableRow({ className, ...props }: HTMLAttributes<HTMLTableRowElement>): JSX.Element {
  return <tr className={cn("align-top", className)} {...props} />;
}

export function TableHeaderCell({ className, children }: { className?: string; children: ReactNode }): JSX.Element {
  return <th className={cn("px-3 py-2 font-semibold", className)}>{children}</th>;
}

export function TableCell({ className, children }: { className?: string; children: ReactNode }): JSX.Element {
  return <td className={cn("px-3 py-2", className)}>{children}</td>;
}
